import { useEffect } from "react";

// On mount, scroll to the element matching the URL hash (for pages whose
// destinations are always rendered, not collapsed inside an accordion).
export function useScrollToHashOnMount() {
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (!hash) return;
    const t = setTimeout(() => {
      document.getElementById(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 150);
    return () => clearTimeout(t);
  }, []);
}
